import fb from "@/main";
import {flatten, groupBy, sumBy,sum } from 'lodash';
import store from '@/state/store'

export default {
  // Active users selectable as Estimator / Project Manager on the job forms
  // (NewJob.vue and Job.vue). Includes Project Manager and Office roles,
  // active (access === true) only, sorted alphabetically by name.
  async getJobAssignees() {
    const snap = await fb.db
      .collection("users")
      .where("role", "in", ["Project Manager", "Office"])
      .get();
    const list = [];
    snap.forEach((u) => {
      const data = u.data();
      if (data.access === true) {
        list.push({
          name: data.firstName + " " + data.lastName,
          email: data.email,
          id: u.id,
          notifications: {
            toolOrders: true,
            toolPickups: true,
            consumablesBudget: true,
          },
        });
      }
    });
    return list.sort((a, b) => a.name.localeCompare(b.name));
  },
  statesList: [
    "AK",
    "AL",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ],
  statesListShort: [
    "NY",
    "NJ",
    "PA",
    "CT",
    "ME",
    "MA"
  ],
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  fulfilledAmount(tool) {
    if (!tool.fulfillments) tool.fulfillments = [];
    if (!tool.fulfillments.length) {
      return tool.qtyFulfilled || 0;
    } else {
      return sumBy(tool.fulfillments, "qty");
    }
  },
  async getToolsOnSite(jobSite) {
      // get tool orders
      const resOrders = await fb.db
        .collection("toolOrders")
        .where("jobSite.id", "==", jobSite.id)
        .get();
      let jobOrders = [];
      resOrders.forEach((u) => {
        jobOrders.push({
          id: u.id,
          ...u.data(),
        });
      });
      jobOrders = jobOrders.filter(jo => !jo.cancelled)
      // get tool pickups
      const pickups = {
        orders: [],
        pickupItems: [],
        groupedPickupItems: [],
      };
      let resPickups = await fb.db
        .collection("toolPickups")
        .where("status", "==", "closed")
        .where("jobSite.id", "==", jobSite.id)
        .get();

      resPickups.forEach((u) => {
        pickups.orders.push({
          id: u.id,
          ...u.data(),
        });
      });

      if (pickups.orders.length) {
        pickups.pickupItems = flatten(pickups.orders.map((p) => p.tools));
        pickups.groupedPickupItems = groupBy(
          pickups.pickupItems,
          (oi) => oi.id
        );
      }
      if (jobOrders.length) {
        //   build table
        const orderItems = flatten(jobOrders.map((jo) => jo.tools));
        const groupedItems = groupBy(orderItems, (oi) => oi.id);
        let toolsFromIndex = await store.dispatch(
          "getToolsFromIndex",
          Object.keys(groupedItems)
        );
        // add id from object id
        toolsFromIndex.forEach((tfi) => {
          tfi.id = tfi.objectID;
        });
        let toolsOnSite = [];
        for (const p in groupedItems) {
          let amountOnSite = sumBy(groupedItems[p], (o) =>
            this.fulfilledAmount(o)
          );
          const rentals = groupedItems[p].filter(f => f.isRental)
          let rentalAmountOnSite = sumBy(rentals, (o) =>
            this.fulfilledAmount(o)
          );
          const toolFromIndex = toolsFromIndex.find(
            (tfi) => groupedItems[p][0].id == tfi.objectID
          );
          let returnedQty = 0;
          if (pickups.groupedPickupItems[groupedItems[p][0].id]) {
            returnedQty = sumBy(
              pickups.groupedPickupItems[groupedItems[p][0].id],
              "returnedQty"
            );
          }
          amountOnSite = amountOnSite - returnedQty;
          if (amountOnSite > 0) {
            toolsOnSite.push({
              totalQty: amountOnSite,
              ...toolFromIndex,
              rentalAmountOnSite
            });
          }
        }
        // filter out consumables or cylinder
        toolsOnSite = toolsOnSite.filter((tos) => {
          return ((tos.id == 'SW2dtoe08FW9fY3fXk2j' || tos.id == 'nwwKZmf4En4YPqJMUiae') || !tos.consumable)
        });

        toolsOnSite = toolsOnSite.map((tos) => {
          return {
            pickupQty: 0,
            ...tos,
          };
        });
        const msg = !toolsOnSite.length ? 'All tools Returned have been returned.' : '';
        const sumOfToolsOnSite = sum(toolsOnSite.map(t=>t.unitPrice*t.totalQty));
        const toolsOnSiteValue = toolsOnSite.length ? this.numberWithCommas(sumOfToolsOnSite.toFixed(2)) : "0.00";
        return {toolsOnSite, msg, toolsOnSiteValue};
      } else {
        return {toolsOnSite:null, msg: "No tools on site found for " + jobSite.address}
      }
  },
  // The name the app and reports show for a truck (app support #95): the
  // friendlyName Alan sets on the Trucks page, else the NexTraq name.
  // Mirrored by truckName() in functions/src/index.ts.
  truckName(truck) {
    if (!truck) return "";
    return truck.friendlyName || truck.name || "";
  },
  async assignDriver(driver, truckId) {
    // remove existing assignments if any
    const truckRes = await fb.db.collection("trucks").where("driver.uid",'==',driver.uid).get()
    if(truckRes.size){
      truckRes.forEach(t => {
        fb.db.collection("trucks").doc(t.id).update({ driver: null });
      })
    }
    await fb.db
      .collection("trucks")
      .doc(truckId)
      .update({ driver: driver });
    return
  },
};
